export default "__VITE_ASSET__BfvMGHK5__"